import { BreakpointConfigType } from '../../constants/types';

export const breakpoint = (theme, key, styles) => {
  let style = ``;

  if (key) {
    style = `
      @media (min-width: ${theme.breakpoint[key]}) {
        ${styles};
      }
  `;
  }

  return style;
};

export const breakpoints = (theme, config: BreakpointConfigType, styles: BreakpointConfigType) => {
  const breakpointStyles: BreakpointConfigType = {};

  const keys = [...Object.keys(theme.breakpoint), 'default'];

  keys.forEach(key => {
    const value = config[key];

    if (value) {
      breakpointStyles[key] = (key === 'default' ? styles[key] : breakpoint(theme, key, styles[key]));
    }
  });

  return breakpointStyles;
};
